import { styled } from "styled-components";

export const StyledHeader = styled.header`
    width: 100%;
    position: relative;
    display: block;
    padding-top: 1.6rem;
`;

export const StyledLayout = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1.6rem;
`;
